var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1,.cls-3{stroke-width:0px;}.cls-2{stroke:#b70d7f;stroke-width:2px;}.cls-4{isolation:isolate;}.cls-3{fill:#b70d7f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.78,17.12h-1.34v2.38h-2.25v-2.38h-4.88v-1.57l4.7-7.25h2.43v7.06h1.34v1.76ZM14.22,10.77h-.05c-.07.19-.21.48-.42.88l-2.4,3.72h2.84v-3.52c0-.31,0-.67.03-1.07Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14,
    cy: 14.5,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 14,
    cy: 14.5,
    r: 11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.e9a27396dba80079342747f2e2a83027.svg";
export { ForwardRef as ReactComponent };